import { RestService } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ArtikelDokument } from '../../../store/models/artikeldokument';

@Injectable({
    providedIn: 'root'
})
export class ArtikelDokumenteService {

    constructor(
        private restService: RestService,
    ) { }

    getListForArtikel(artikelKennung: number) : Observable<ArtikelDokument.IArtikelDokumentsDto> {
        return this.restService.request<void, ArtikelDokument.IArtikelDokumentsDto>({
            method: 'GET',
            url: '/api/app/artikel-dokument/for-artikel?artikelKennung=' + artikelKennung
        });
    }

    getById(id: number) : Observable<Blob> {
        return this.restService.request<void, Blob>({
            method: 'GET',
            url: '/api/app/artikel-dokument/' + id + '/by-id',
            responseType: 'blob',
        });
    }


    // getById(id: number) : Observable<ArtikelDokument.IArtikelDokumentDto> {
    //     return this.restService.request<void, ArtikelDokument.IArtikelDokumentDto>({
    //         method: 'GET',
    //         url: '/api/app/artikel-dokument/' + id
    //     });
    // }
}
